import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingPieChartWidget } from '../../pie-chart-widget/pie-chart-widget.component';
import { EveReportingWidgetDataSourceType } from '../../widget-menu-settings/widget-datasource/widget-datasource.component';



@Component({
  selector: 'pie-chart-widget-menu-settings',
  templateUrl: 'pie-chart-widget-menu-settings.component.html',
  styleUrls: ['./pie-chart-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class PieChartWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingPieChartWidget = null;

  constructor(

  ) {


  }

  ngOnInit(): void {
    //TODO: this isnt right
    if (this.widget != null && this.widget.dataSource?.type != EveReportingWidgetDataSourceType.EveSingleChart) this.widget.dataSource = {
      type: EveReportingWidgetDataSourceType.EveSingleChart
    };
  }


}



